var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12348_4398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19259 1.56667C1.89398 1.56667 1.60759 1.68529 1.39644 1.89644C1.18529 2.10759 1.06667 2.39398 1.06667 2.69259V14.3074C1.06667 14.606 1.18529 14.8924 1.39644 15.1036C1.60759 15.3147 1.89398 15.4333 2.19259 15.4333H5.51111C5.80566 15.4333 6.04444 15.6721 6.04444 15.9667C6.04444 16.2612 5.80566 16.5 5.51111 16.5H2.19259C1.61108 16.5 1.05339 16.269 0.642195 15.8578C0.231005 15.4466 0 14.8889 0 14.3074V2.69259C0 2.11108 0.231004 1.55339 0.642195 1.1422C1.05339 0.731005 1.61108 0.5 2.19259 0.5H5.51111C5.80566 0.5 6.04444 0.738781 6.04444 1.03333C6.04444 1.32789 5.80566 1.56667 5.51111 1.56667H2.19259Z",
    fill: "#330072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9414 3.97496C11.1496 3.76668 11.4873 3.76668 11.6956 3.97496L15.8438 8.12311C16.052 8.33139 16.052 8.66908 15.8438 8.87736L11.6956 13.0255C11.4873 13.2338 11.1496 13.2338 10.9414 13.0255C10.7331 12.8172 10.7331 12.4795 10.9414 12.2713L14.1793 9.03333H5.5112C5.21665 9.03333 4.97786 8.79455 4.97786 8.5C4.97786 8.20545 5.21665 7.96667 5.5112 7.96667H14.1788L10.9414 4.72921C10.7331 4.52093 10.7331 4.18324 10.9414 3.97496Z",
    fill: "#330072"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12348_4398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/logOutIcon.6b43c2cb6e615ba137067ea37aecad38.svg";
export { ForwardRef as ReactComponent };